<template>
    <v-menu
            :close-on-content-click="false"
            min-width="200px"
            v-model="openPicker"
    >
        <template v-slot:activator="">
            <v-text-field
                    :loading="loading"
                    @blur="updateIsoDate"
                    @click:append="openPicker = true"
                    append-icon="far fa-calendar-alt"
                    dense
                    flat
                    solo-inverted
                    v-model="dateFormatted"
            ></v-text-field>
        </template>
        <v-date-picker @click:date="isoDateFun" @input="openPicker = false" no-title v-model="isoDate"></v-date-picker>
    </v-menu>
</template>

<script>
    import {mask} from 'vue-the-mask'
    import moment from 'moment'
    import {HTTP} from "../http";

    export default {
        name: "SaveDatePicker",
        props: {
            isoDateInput: {
                type: String,
                required: true
            },
            toast: {
                type: Object,
                required: true
            },
            LicenceID: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: true
            }
        },
        model: {
            prop: 'isoDateInput',
            event: 'input'
        },
        data: () => ({
            dateFormatted: "",
            time: "",
            loading: false,
            isoDate: "",
            openPicker: false
        }),
        directives: {
            mask,
        },

        methods: {
            isoDateFun() {
                this.save();
                this.dateFormatted = this.formatDateFromIso(this.isoDate.substr(0, 10));

            },
            save() {
                this.$emit('input', this.isoDate + this.time)
                this.loading = true;
                let requestBody;

                if (this.type === 'von') {
                    requestBody = {
                        LicenceID: this.LicenceID,
                        DateFrom: this.isoDate + this.time
                    };
                } else {
                    requestBody = {
                        LicenceID: this.LicenceID,
                        DateTo: this.isoDate + this.time
                    };
                }
                HTTP.post("api/Licence/Date", requestBody).then(() => {
                    this.loading = false;
                    this.toast.show = true;
                }).catch(() => {
                    this.loading = false;
                })

            },
            updateIsoDate() {
                this.isoDate = this.parseDate(this.dateFormatted);
                this.save();
            },
            formatDateFromIso(date) {
                if (!date) return null
                const [year, month, day] = date.split('-')
                return `${day}.${month}.${year}`
            },
            parseDate(date) {
                if (!date) return null
                if (!moment(date, 'DD.MM.YYYY', true).isValid()) return null
                const [day, month, year] = date.split('.')
                this.$emit("input", this.isoDate);
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        },
        mounted() {
            this.isoDate = this.isoDateInput.substr(0, 10);
            this.dateFormatted = this.formatDateFromIso(this.isoDateInput.substr(0, 10));
            this.time = this.isoDateInput.substr(10);

        }
    }
</script>